import { PartialType } from '@nestjs/swagger';
import { CreateEmpresaMonedaDto } from './create-empresa-moneda.dto';

export class UpdateEmpresaMonedaDto extends PartialType(CreateEmpresaMonedaDto) {}
